// extracted by mini-css-extract-plugin
export default {"container":"ModalBody_container__C4ctt"};